import React from 'react'

import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch, useSelector } from 'react-redux'

import Loading from '@components/UI/Loading'
import { BrandFanFilters } from '@enums'
import { IApplicationState } from '@store'
import {
  fetchInfluencerIdentities,
  selectBrandFansNextLink,
  selectFilteredIdentityIds,
  selectIsFetchingInitialIdentityList,
  selectIsListEmpty,
} from '@store/brandFans'
import { Container } from '@tribegroup'
import { isEmpty } from '@utils'
import BrandFanInfluencerIdentityRow from '../Row'
import InfluencerIdentityListEmpty from './Empty'
import InfluencerIdentityListEmptyFiltered from './EmptyFiltered'

interface IProps {
  filter: BrandFanFilters
}

const InfluencerIdentityList: React.FC<IProps> = ({ filter }) => {
  const dispatch = useDispatch()
  const isLoadingInitialList = useSelector((state: IApplicationState) =>
    selectIsFetchingInitialIdentityList(state, filter),
  )
  const isEmptyList = useSelector((state: IApplicationState) => selectIsListEmpty(state, filter))
  const influencerIdentityIds = useSelector((state: IApplicationState) =>
    selectFilteredIdentityIds(state, filter),
  )
  const hasMore = useSelector((state: IApplicationState) =>
    Boolean(selectBrandFansNextLink(state, filter)),
  )
  const filteredListIsEmpty = isEmpty(influencerIdentityIds)
  React.useEffect(() => {
    if (filteredListIsEmpty) {
      dispatch(fetchInfluencerIdentities())
    }
  }, [filter])

  if (isLoadingInitialList) {
    return <Loading height={15} />
  }

  if (isEmptyList) {
    return <InfluencerIdentityListEmpty type={filter} />
  }

  if (filteredListIsEmpty) {
    return <InfluencerIdentityListEmptyFiltered />
  }

  const fetchNext = () => {
    const isFetchNext = true
    dispatch(fetchInfluencerIdentities(isFetchNext))
  }

  return (
    <Container topOuterSpacing={1} bottomInnerSpacing={4.5}>
      <InfiniteScroll
        dataLength={influencerIdentityIds.length}
        next={fetchNext}
        loader={<Loading height={30} />}
        hasMore={hasMore}
        scrollThreshold={0.8}
        style={{ overflow: 'hidden' }}
      >
        <div data-testid="brand-fans-influencer-identity-list">
          {influencerIdentityIds.map((influencerIdentityId: number) => (
            <BrandFanInfluencerIdentityRow
              key={influencerIdentityId}
              identityId={influencerIdentityId}
            />
          ))}
        </div>
      </InfiniteScroll>
    </Container>
  )
}

export { InfluencerIdentityList }
export default InfluencerIdentityList
